(() => {
  if (window.__awCompatibilitySafetyLoaded) return;
  window.__awCompatibilitySafetyLoaded = true;

  const plain = (v = '') => String(v).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, ' ').replace(/[^a-z0-9./+ -]+/g, ' ').replace(/\s+/g, ' ').trim();
  const norm = (v = '') => plain(v).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const badStatus = (value = '') => {
    const status = norm(value);
    return status === 'a-verifier' || status.includes('incompatible') || status.includes('non-compatible') || status.includes('bloqu') || status.includes('blocked') || status.includes('refus');
  };
  const negative = (text = '') => /non couvert|non destine|non compatible|incompatible|exclu|ne pas|pas automatiquement|ne devient pas compatible|ne valide pas/.test(plain(text));
  const family = (value = '') => {
    const text = plain(value);
    const out = new Set();
    if (/\baeg\b|\baep\b|electrique|\bngrs\b|next gen|recoil shock|\bebbr?\b/.test(text)) out.add('aeg');
    if (/\bgbbr?\b|\bmws\b|\bgaz\b|\bgas\b|\bco2\b|\bnbb\b/.test(text)) out.add('gas');
    if (/\bhpa\b/.test(text)) out.add('hpa');
    if (/\bspring\b|ressort/.test(text)) out.add('spring');
    return out;
  };
  const disjoint = (a, b) => a.size && b.size && ![...a].some((item) => b.has(item));
  const strictTypeCategories = new Set(['magazines', 'upgrade', 'hpa', 'power']);
  const rootFor = (card) => card?.closest?.('[data-aw-compatible-products]');
  const currentRelations = () => {
    const node = document.querySelector('[data-aw-current-compatibility-relations]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (_) { return []; }
  };
  const currentPlatform = (root) => {
    const fixed = norm(root?.dataset?.defaultPlatform || '');
    if (fixed) return fixed;
    const label = String(root?.querySelector?.('[data-aw-platform-summary] [data-aw-platform-label]')?.textContent || '').split('·')[0];
    return norm(label);
  };
  const currentTitle = () => plain(document.querySelector('main h1, h1')?.textContent || '');
  const matchingCurrentRelations = (root) => {
    const selected = currentPlatform(root);
    return currentRelations().filter((relation) => !selected || norm(relation?.platform || '') === selected);
  };

  const generations = (value = '') => {
    const text = plain(value);
    const out = new Set();
    for (const match of text.matchAll(/\bgen(?:eration)?\s*([1-9])\s*(?:a|to|-)\s*([1-9])\b/g)) {
      const start = Number(match[1]);
      const end = Number(match[2]);
      for (let i = Math.min(start, end); i <= Math.max(start, end); i += 1) out.add(i);
    }
    for (const match of text.matchAll(/\bgen(?:eration)?\s*([1-9])\b/g)) out.add(Number(match[1]));
    return out;
  };
  const glockModels = (value = '') => {
    const text = plain(value);
    const out = new Set();
    const models = ['17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','42','43','44','45','46','47','48','49'];
    models.forEach((model) => {
      const re = new RegExp(`\\b(?:glock\\s*)?g?${model}\\b`, 'g');
      if (re.test(text)) out.add(model);
    });
    return out;
  };
  const setOverlap = (a, b) => !a.size || !b.size || [...a].some((item) => b.has(item));
  const generationOrModelConflict = (root, card) => {
    const current = currentTitle();
    const candidateTitle = plain(card.querySelector('.aw-compatible-card__title')?.textContent || '');
    const condition = plain(card.dataset.awRelationCondition || '');
    const candidate = `${candidateTitle} ${condition}`;
    const currentGen = generations(current);
    const candidateGen = generations(candidate);
    if (!setOverlap(currentGen, candidateGen)) return true;
    if (currentPlatform(root) === 'glock') {
      const currentModels = glockModels(current);
      const candidateModels = glockModels(candidate);
      if (!setOverlap(currentModels, candidateModels)) return true;
    }
    return false;
  };
  const dependencyConflict = (card) => {
    const condition = plain(card?.dataset?.awRelationCondition || '');
    const current = currentTitle();
    if (/\bx300u?\b/.test(condition) && !/\bx300u?\b/.test(current)) return true;
    return false;
  };

  const explicitTokenConflict = (motif, candidateText) => {
    const m = plain(motif);
    const c = plain(candidateText);
    if (!m || !c || !negative(m)) return false;
    const tokens = ['gbbr','mws','hpa','co2','spring','gaz','gas','aeg','ebb','arp9','prk9','9mm','9 mm','sr25','308','dor','mk1','mk2','mk3','gen2','gen 2','gen3','gen 3','gen4','gen 4','gen5','gen 5'];
    return tokens.some((token) => m.includes(token) && c.includes(token));
  };

  const magazineConflict = (motif, card) => {
    if (card?.dataset?.awMerchCategory !== 'magazines') return false;
    const m = plain(motif);
    const title = plain(card.querySelector('.aw-compatible-card__title')?.textContent || '');
    if (!negative(m)) return false;
    const platforms = ['m4','ak','g36','mp5','hi capa','m1911','sr25','m110','arp9','prk9','ppk 20'];
    return platforms.some((token) => (m.includes(`chargeur ${token}`) || m.includes(`chargeurs ${token}`)) && title.includes(token));
  };

  const contextualConflict = (card) => {
    if (!card) return false;
    if (card.dataset.awRelationBlocked === 'true') return true;
    if (card.dataset.awHasRelations === 'true' && card.dataset.awRelationFound !== 'true') return true;
    const motif = card.dataset.awRelationMotif || '';
    const root = rootFor(card);
    const currentTypes = family(root?.dataset?.currentTypes || '');
    const candidateTypes = family(`${card.dataset.types || ''} ${card.querySelector('.aw-compatible-card__title')?.textContent || ''}`);
    const category = card.dataset.awMerchCategory || 'other';

    if (generationOrModelConflict(root, card)) return true;
    if (dependencyConflict(card)) return true;

    // Propulsion-sensitive components may never cross AEG/GBB-GBBR/HPA/Spring families
    // only because they share a platform, brand or keyword.
    if (strictTypeCategories.has(category) && disjoint(currentTypes, candidateTypes)) return true;

    if (String(motif).trim()) {
      if (disjoint(currentTypes, candidateTypes) && negative(motif)) return true;
      if (!candidateTypes.size && currentTypes.size) {
        const motifText = plain(motif);
        if (currentTypes.has('gas') && /(gbbr|mws|gaz|gas|co2)/.test(motifText) && negative(motifText)) return true;
        if (currentTypes.has('hpa') && /\bhpa\b/.test(motifText) && negative(motifText)) return true;
        if (currentTypes.has('spring') && /(spring|ressort)/.test(motifText) && negative(motifText)) return true;
        if (currentTypes.has('aeg') && /\baeg\b/.test(motifText) && negative(motifText) && /(non couvert|exclu|incompatible|non compatible|non destine)/.test(motifText)) return true;
      }
      if (explicitTokenConflict(motif, currentTitle())) return true;
    }

    for (const relation of matchingCurrentRelations(root)) {
      if (badStatus(relation?.status)) return true;
      const currentMotif = String(relation?.motif || '');
      const candidateText = `${card.querySelector('.aw-compatible-card__title')?.textContent || ''} ${card.dataset.types || ''}`;
      if (explicitTokenConflict(currentMotif, candidateText)) return true;
      if (magazineConflict(currentMotif, card)) return true;
    }
    return false;
  };

  const applyPackGuards = (scope = document) => {
    scope.querySelectorAll?.('[data-aw-compatible-products] [data-aw-product-card]').forEach((card) => {
      const conflict = contextualConflict(card);
      const hard = card.dataset.awRelationBlocked === 'true';
      const hasCondition = card.dataset.awRelationExclusion === 'true';
      const checkbox = card.querySelector('[data-aw-product-checkbox]');
      const selector = checkbox?.closest('.aw-compatible-card__selector');
      const quick = card.querySelector('[data-aw-quick-add]');
      const badge = card.querySelector('[data-aw-card-badge]');

      if (conflict) {
        card.dataset.awEligible = 'false';
        card.dataset.awTechnicalConflict = 'true';
        if (checkbox) { checkbox.checked = false; checkbox.disabled = true; }
        if (selector) selector.hidden = true;
        if (quick) { quick.disabled = true; quick.hidden = true; }
        if (badge) badge.textContent = hard ? 'Compatibility AW — à vérifier' : 'Incompatible avec la configuration sélectionnée';
        return;
      }

      card.dataset.awTechnicalConflict = 'false';
      if (hasCondition && card.dataset.awEligible === 'true' && badge) badge.textContent = 'Vérifié AW — sous conditions';
    });
  };

  const paintCheckerSafety = () => {
    const root = document.querySelector('[data-aw-compatibility]');
    if (!root) return;
    const select = root.querySelector('[data-aw-platform-select]');
    const selected = norm(select?.value || '');
    if (!selected) return;
    const matches = currentRelations().filter((relation) => norm(relation?.platform || '') === selected);
    if (!matches.length) return;
    const blocked = matches.find((relation) => badStatus(relation?.status));
    const caution = matches.find((relation) => String(relation?.motif || '').trim());
    if (!blocked && !caution) return;
    const result = root.querySelector('[data-aw-result]');
    const title = root.querySelector('[data-aw-title]');
    const message = root.querySelector('[data-aw-message]');
    const icon = root.querySelector('[data-aw-icon]');
    const scoreValue = root.querySelector('[data-aw-score-value]');
    const scoreFill = root.querySelector('[data-aw-score-fill]');
    const scoreLabel = root.querySelector('[data-aw-score-label]');
    if (blocked) {
      if (result) result.className = 'aw-compatibility__result aw-compatibility__result--unknown';
      if (title) title.textContent = 'Compatibilité à vérifier avant commande';
      if (message) message.textContent = String(blocked.condition || blocked.motif || 'Compatibility AW ne valide pas cette configuration comme achetable automatiquement.');
      if (icon) icon.textContent = '?';
      if (scoreValue) scoreValue.textContent = '0%';
      if (scoreFill) scoreFill.style.width = '0%';
      if (scoreLabel) scoreLabel.textContent = 'Blocage Compatibility AW prioritaire sur marque, plateforme et mots-clés.';
      return;
    }
    if (result) result.className = 'aw-compatibility__result aw-compatibility__result--conditional';
    if (title) title.textContent = 'Compatible sous conditions';
    if (message) message.textContent = String(caution.condition || caution.motif || 'Vérifiez la configuration exacte avant commande.');
    if (icon) icon.textContent = '!';
    if (scoreLabel) scoreLabel.textContent = 'La plateforme seule ne suffit pas : les exclusions techniques AW restent prioritaires.';
  };

  const guardedCard = (card) => contextualConflict(card);
  const apply = (scope = document) => { applyPackGuards(scope); paintCheckerSafety(); };

  document.addEventListener('click', (event) => {
    const quick = event.target.closest?.('[data-aw-quick-add]');
    if (quick && guardedCard(quick.closest('[data-aw-product-card]'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const addSelected = event.target.closest?.('[data-aw-add-selected]');
    if (addSelected) applyPackGuards(document);
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches?.('[data-aw-platform-select], [data-aw-manufacturer-select], [data-aw-replica-type-select]')) setTimeout(() => apply(document), 0);
  }, true);
  addEventListener('aw:compatibility-changed', () => setTimeout(() => apply(document), 0));
  addEventListener('aw:platform-changed', () => setTimeout(() => apply(document), 0));

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes?.length)) setTimeout(() => apply(document), 0);
  });
  const start = () => { apply(document); observer.observe(document.documentElement, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
